<template>
  <div class="fora">
    <div class="topo-header centro">
      <botao-voltar class="voltar" nomeRota="Servidor" />
      <h1>Visualizar Servidor(a)</h1>
    </div>
    
    <div class="form centro">
      <!-- BLOCO 1: DADOS DO SERVIDOR -->
      <div class="dados">
        <fieldset>
          <div class="dados">
            <div class="flexbox-3">
              <p class="item">CPF: 
                <span>{{ formatarCPF(servidor.cpf) }}</span>
              </p>
              <p class="item">Nome:
                <span>{{ servidor.nome }}</span>
              </p>
            </div>
            <div class="form-cargos item">
              <p>Lotação(ões):</p>
              <div class="flexbox-1">
                <template v-for="lotacao in servidor.lotacao_servidores">
                  <fieldset :key="lotacao.id" class="cargos">
                    <div class="nome">
                      <div class="linha-lotacao">
                        <p>Unidade: 
                          <span>{{ lotacao.unidade.nome }}</span>
                        </p>
                        <p>Representante: 
                          <span>{{ lotacao.representante ? 'Sim' : 'Não' }}</span>
                        </p>
                      </div>
                      <div class="linha-lotacao">
                        <p v-if="lotacao.unidade_superior">Unidade Superior: 
                          <span>{{ lotacao.unidade_superior.nome }}</span>
                        </p>
                      </div>
                      <div class="linha-lotacao">
                        <p>Data de Início: 
                          <span>{{ formatarData(lotacao.data_inicio) }}</span>
                        </p>
                        <p>Data de Fim: 
                          <span>{{ formatarData(lotacao.data_final) }}</span>
                        </p>
                      </div>
                    </div>
                  </fieldset>
                </template>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <!-- BOTÕES -->
      <div class="bt-editar" v-if="podeEscrever('servidores')">
        <div class="div-center">
          <div :id="servidor.id">
            <a :href="'/servidores/' + servidor.id + '/edit'">
              <button id="botao-editar">
                Editar
              </button>
            </a>
          </div>
        </div>
      </div>
      
      <p></p>
      
      <!-- BLOCO 2: NOVO BANNER DO HISTÓRICO -->
      <div class="dados">
        <fieldset>
          <div class="dados2">
            
            <h2 class="titulo-historico">Histórico de Formulários Respondidos</h2>
                        
            <div class="bt-editar container-btn-historico" v-if="historico.length > 0">
              <div class="div-center">
                <button id="botao-editar" @click="baixarRelatorioGeralPdf">
                  Histórico Completo em PDF
                </button>
              </div>
            </div>
            <p></p>
            
            <p v-if="carregandoHistorico" class="texto-aviso">Buscando histórico...</p>
            
            <table class="table tabela-historico" v-else-if="historico.length > 0">
              <thead>
                <tr>
                  <th>Título do Formulário</th>
                  <th>Unidade</th>
                  <th>Período</th>                  
                  <th class="coluna-acoes-header">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in historico" :key="item.id">
                  <td>
                    <router-link :to="{ name: 'VisualizarRespostaFormulario', params: { id: item.id } }" class="link-formulario">
                    {{ item.titulo }}
                    </router-link>
                  </td>
                  <td>
                    {{ item.unidade_nome }} 
                    <span v-if="item.unidade_sigla" class="sigla-destaque">({{ item.unidade_sigla }})</span>
                  </td>
                  <td class="coluna-periodo">
                    {{ formatarData(item.data_inicio) }} a 
                    {{ item.data_final ? formatarData(item.data_final) : 'Atualmente' }}
                  </td>
                  <td class="coluna-acoes">
                    <div class="icone-tabela" @click="abrirModalRespostas(item.id)">
                      <img src="../../assets/imagens/icon-view.svg" alt="Visualizar Respostas" title="Visualizar Respostas" class="icone-olho" />
                    </div>
                    <div class="icone-tabela" @click="baixarRelatorioPdf(item)">
                      <img src="../../assets/imagens/icon-pdf.svg" alt="Baixar PDF" title="Baixar PDF deste Formulário Respondido" class="icone-pdf" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            
            <!-- MENSAGEM SE NÃO TIVER HISTÓRICO -->
            <p v-else class="texto-aviso msg-sem-historico">
              Nenhum histórico de formulários respondidos encontrado.
            </p>

            <!-- MODAL NATIVO DA TELA -->
            <div class="modal-mask" v-if="mostrarModalRespostas" @click.self="fecharModalRespostas">
              <div class="modal-wrapper">
                <div class="modal-container">
                  <div class="modal-header">
                    <h3>
                      Respostas preenchidas por:
                      <span v-if="carregandoRespostas">...</span>
                      <span v-else>{{ nomesAvaliadores }}</span>
                    </h3>
                    <button @click="fecharModalRespostas" class="close-button">&times;</button>
                  </div>
                  <div class="modal-body">
                    <div v-if="carregandoRespostas">Buscando respostas...</div>
                    <div v-else-if="modalRespostasLocal.length === 0">Nenhuma resposta encontrada.</div>
                    <ul v-else>
                      <li v-for="(resposta, index) in modalRespostasLocal" :key="index" class="resposta-item">
                        <p><strong>{{ index + 1 }}. {{ resposta.pergunta }}</strong></p>
                        <span>R: {{ resposta.resposta }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </fieldset>
      </div>
      <p></p>  
    </div>
        
    <div>
      <Footer
        :createdByLabel="'Criado por'"
        :criadoPor="servidor.criado_por"
        :lastUpdatedByLabel="'Última atualização feita por'"
        :atualizadoPor="servidor.atualizado_por"
        :emLabel="' em '"
        :SistemaLabel="'Sistema'"
        :created_at="servidor.created_at"
        :updated_at="servidor.updated_at"
      />
    </div>
  </div>
</template>

<script>
  import BotaoVoltar from "../BotaoVoltar.vue";
  import ServidorApi from "../../services/ServidorApi";
  import { parseISO, format } from "date-fns"
  import Footer from "../Footer.vue"  

  export default {
    name: "ExibirServidor",
    props: {
      servidor: Object,
    },
    data() {
      return {
        count: null,
        salvando: false,
        erro: false,
        erroSalvar: false,
        hasError: false,
        r: false,

        dadosServidores: {
          criado_por: null,
          atualizado_por: null,
          created_at: null,
          updated_at: null,
        },
        
        carregandoHistorico: false,
        historico: [],
        mostrarModalRespostas: false,
        formularioSelecionadoId: null,
        carregandoRespostas:false,
        modalRespostasLocal:[],
        avaliadoresModal: [],
      
      }
    },
    computed: {
      nomesAvaliadores() {
        if (this.avaliadoresModal.length === 0) return 'Avaliador não identificado';
        return this.avaliadoresModal.join(', ');
      },
    },
    created() {
      this.ServidorApi = new ServidorApi();
    },
    mounted() {
      if (this.servidor && this.servidor.id) {
        this.buscarHistorico();
      }
    },
    watch: {
      'servidor.id': function(novoId) {
        if (novoId) {
          this.buscarHistorico();
        }
      }
    },
    components: {
      BotaoVoltar,
      Footer,      
    },
    methods: {
      async baixarRelatorioPdf(item) {
        if (!item || !item.id) return;

        // Feedback visual para o usuário não clicar várias vezes
        const toastId = this.$bvToast.toast('Gerando PDF das respostas. Aguarde...', {
          title: 'Gerando Documento',
          variant: 'info',
          solid: true,
          noAutoHide: true
        });

        try {
          const response = await this.ServidorApi.gerarPdfRespostas(item.id, this.servidor.id);
          
          const contentDisposition = response.headers['content-disposition'];
          let filename;
          
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
            if (filenameMatch && filenameMatch.length > 1) {
              filename = filenameMatch[1];
            }
          }
          
          if (!filename) {
            filename = `respostas_${this.servidor.nome.replace(/\s+/g, '_')}_${item.titulo.replace(/\s+/g, '_')}.pdf`;
          }

          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);

          this.$bvToast.hide(toastId);

        } catch (error) {
          this.$bvToast.hide(toastId);
          console.error("Erro ao gerar PDF:", error);
          this.$bvToast.toast('Não foi possível gerar o PDF das respostas no momento.', { 
            title: 'Erro', 
            variant: 'danger', 
            solid: true 
          });
        }
      },
      async baixarRelatorioGeralPdf() {
        // Feedback visual
        const toastId = this.$bvToast.toast('Gerando o Dossiê completo em PDF. Isso pode demorar um pouco...', {
          title: 'Gerando Documento',
          variant: 'info',
          solid: true,
          noAutoHide: true
        });

        try {
          // Chamada para a nova função da API
          const response = await this.ServidorApi.gerarPdfHistoricoGeral(this.servidor.id);
          
          const contentDisposition = response.headers['content-disposition'];
          let filename;
          
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
            if (filenameMatch && filenameMatch.length > 1) {
              filename = filenameMatch[1];
            }
          }
          
          if (!filename) {
            filename = `Historico_Geral_${this.servidor.nome.replace(/\s+/g, '_')}.pdf`;
          }

          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);

          this.$bvToast.hide(toastId);
        } catch (error) {
          this.$bvToast.hide(toastId);
          console.error("Erro ao gerar PDF geral:", error);
          this.$bvToast.toast('Não foi possível gerar o histórico completo em PDF no momento.', { 
            title: 'Erro', 
            variant: 'danger', 
            solid: true 
          });
        }
      },
      async abrirModalRespostas(idFormulario) {
        this.formularioSelecionadoId = idFormulario;
        this.mostrarModalRespostas = true;
        this.carregandoRespostas = true;
        this.modalRespostasLocal = [];
        this.avaliadoresModal = [];

        try {
          const data = await this.ServidorApi.getRespostasComoAvaliador(this.servidor.id, idFormulario);
          this.modalRespostasLocal = data.respostas;
          this.avaliadoresModal = data.avaliadores || [];
        } catch (erro) {
          console.error("Erro ao buscar respostas:", erro);
          this.$bvToast.toast('Não foi possível carregar as respostas.', { title: 'Erro', variant: 'danger', solid: true });
        } finally {
          this.carregandoRespostas = false;
        }
      },
      fecharModalRespostas() {
        this.mostrarModalRespostas = false;
        this.formularioSelecionadoId = null;
        this.avaliadoresModal = [];
      },
      async buscarHistorico() {
        this.carregandoHistorico = true;
        this.historico = []; 

        try {
          const dados = await this.ServidorApi.getHistoricoServidor(this.servidor.id);
          this.historico = dados;
        } catch (erro) {
          console.error("Erro ao buscar o histórico:", erro);
          alert("Não foi possível carregar o histórico no momento.");
        } finally {
          this.carregandoHistorico = false;
        }
      },
      formatarData: function (value) {
        if (!value) return "";
        return format(parseISO(value), "dd/MM/yyyy");
      },
      formatarCPF(cpf) {
        // Lógica para formatar o CPF (exemplo: 123.456.789-01)
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .linha-lotacao {
    display: flex;
    justify-content: flex-start;
    gap: 1rem;
  }
  /* ESTILOS DO NOVO CABEÇALHO DO HISTÓRICO */
  .header-historico {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }

  .titulo-historico {
    font-size: 1.2em;
    margin: 0 0 20px 0;
  }

  .container-btn-historico {
    display: flex;
    justify-content: flex-end; 
    margin-bottom: 25px; 
    width: 100%; 
  }

  .btn-baixar-historico {
    margin: 0 !important;
    padding: 0.5rem 1rem !important;
    width: auto !important;
  }

  .coluna-acoes-header {
    text-align: center;
  }

  .msg-sem-historico {
    font-family: 'Montserrat-Medium';
    font-size: 1.1rem;
    font-weight: normal;
    margin-left: 0.3rem;
  }

  /* ESTILOS ESPECÍFICOS DO BANNER DO HISTÓRICO */
  .tabela-historico {
    background: transparent;
    font-family: "Montserrat-Medium";
    width: 100%;
    text-align: left;
    border-collapse: collapse;
  }
  .tabela-historico th, .tabela-historico td {
    padding: 10px;
    border-bottom: 1px solid #ccc;
  }
  .sigla-destaque {
    font-family: "Montserrat-Medium";
    font-size: 1.1rem;
  }
  .dados2 {
    font-size: 1rem;
    font-family: "Montserrat-bold";
    font-weight: bold;
  }

  .link-formulario {
    color: #005516; /* O mesmo verde escuro da sombra que você usa */
    text-decoration: none;
    font-weight: bold;
    transition: color 0.2s ease;

    &:hover {
      color: #008f25; /* Um verde um pouco mais claro ao passar o mouse */
      text-decoration: underline;
    }
  }
  .coluna-acoes {
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
  }
  .icone-tabela {
    display: inline-block;
    margin: 0 5px;
  }

  .icone-olho, .icone-pdf {
    width: 24px;
    height: auto;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.2);
    }
  }

  /* ESTILOS DO MODAL NATIVO */
  .modal-mask {
    position: fixed; z-index: 9998; top: 0; left: 0; width: 100%; height: 100%;
    background-color: rgba(0, 0, 0, 0.5); display: table; transition: opacity 0.3s ease;
  }
  .modal-wrapper { display: table-cell; vertical-align: middle; }
  .modal-container {
    width: 800px; max-width: 90%; margin: 0px auto; padding: 20px 30px;
    background-color: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  }
  .modal-header {
    display: flex; justify-content: space-between; align-items: center;
    color: #005516; border-bottom: 2px solid #f0f0f0; padding-bottom: 15px; margin-top: 0;
  }
  .modal-header h3 { margin: 0; font-size: 1.25rem; }
  .modal-body { margin: 25px 0; max-height: 60vh; overflow-y: auto; text-align: left; }
  .close-button {
    background: none; border: none; font-size: 1.5rem; line-height: 1;
    cursor: pointer; color: #aaa; padding: 0;
  }
  .close-button:hover { color: #333; }
  .modal-body ul { list-style: none; padding: 0; }
  .resposta-item { margin-bottom: 1.5rem; padding-bottom: 1.5rem; border-bottom: 1px solid #f0f0f0; }
  .resposta-item:last-child { border-bottom: none; margin-bottom: 0; padding-bottom: 0; }
  .resposta-item p { margin: 0; font-size: 1rem; color: #333; }
  .resposta-item span {
    display: block; margin-top: 0.5rem; padding-left: 1rem;
    font-size: 0.95rem; color: #555; font-style: italic;
  }

  @media screen and (min-width: 1066px) {
    .fora {
      .form {
        fieldset {
          .dados {
            .flexbox-1 {
              display: grid;
              grid-template-columns: 1fr;
              gap: 1rem;
            }
          }
        }

        .form-cargos {
          margin: 0 0 2rem 0;

          fieldset.cargos {
            background-color: #dbdbdb;
            padding: 1rem 1rem;
            border-radius: 1rem;
            box-shadow: #000000 0px 5px 15px;
            width: 80%;
            justify-self: center;
            text-align: center;

            .dados {
              border-radius: 0.7rem;
              padding-top: 1%;
              display: grid;

              p {
                font-family: "Montserrat-Medium";
                font-size: 1.1rem;
                font-weight: bold;
                display: inline-block;
                width: fit-content;
                margin: 0 0 2rem 0;
              }

              span {
                font-size: 1.1rem;
                font-weight: normal;
              }

              .flexbox-1 {
                display: grid;
                grid-template-columns: .5fr .5fr;
                gap: 2rem;
              }

              .flexbox-2 {
                display: grid;
                grid-template-columns: .3fr 1fr .3fr;
                gap: 2rem;
              }
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: 600px) and (max-width: 1065px) {
    .fora {
      width: 100%;
      min-height: 100vh;
      background-color: #f8f8f8;
      margin: 0;
      padding: 1.25rem;

      .form {
        .form-cargos {
          margin: 0 0 2rem 0;

          div.flexbox-1 {
            display: grid;
            grid-template-columns: 1fr;
            gap: 2rem;
          }

          fieldset.cargos {
            background-color: #dbdbdb;
            padding: 1rem 1rem;
            border-radius: 1rem;
            box-shadow: #000000 0px 5px 15px;
            width: 80%;
            justify-self: center;
            text-align: center;

            .dados {
              border-radius: 0.7rem;
              padding-top: 1%;
              display: grid;

              p {
                font-family: "Montserrat-Medium";
                font-size: 1.1rem;
                font-weight: bold;
                display: inline-block;
                width: fit-content;
                margin: 0 0 2rem 0;
              }

              span {
                font-size: 1.1rem;
                font-weight: normal;
              }
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: 80px) and (max-width: 599px) {
    .fora {
      width: 100%;
      min-height: 100vh;
      background-color: #f8f8f8;
      margin: 0;
      padding: 1.25rem;

      .form {
        .form-cargos {
          margin: 0 0 2rem 0;

          .flexbox-1 {
            display: flex;
            flex-direction: column;
            gap: 2rem;
          }

          fieldset.cargos {
            background-color: #dbdbdb;
            padding: 1rem 1rem;
            border-radius: 1rem;
            box-shadow: #000000 0px 5px 15px;
            margin: 0rem 2rem;
            text-align: center;

            .dados {
              border-radius: 0.7rem;
              padding-top: 1%;
              display: grid;

              p {
                font-family: "Montserrat-Medium";
                font-size: 1.1rem;
                font-weight: bold;
                display: inline-block;
                width: fit-content;
                margin: 0 0 2rem 0;
              }

              span {
                font-size: 1.1rem;
                font-weight: normal;
              }
            }
          }
        }
      }
    }
  }
</style>